// extracted by mini-css-extract-plugin
module.exports = {"Icon":"PageIcon_Icon__TxgtQ","AddIcon":"PageIcon_AddIcon__2TmEJ","DefaultIcon":"PageIcon_DefaultIcon__3YMwZ"};